var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _polygon, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _polygon2, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _ellipse, _path26, _path27, _path28, _rect, _rect2, _circle, _circle2, _circle3, _path29, _path30, _path31, _rect3, _path32, _path33, _rect4, _ellipse2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformacionmedicaCenfotec(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_9",
    "data-name": "Layer 9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 342.55 565.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-17,.cls-2{fill:#333;}.cls-11,.cls-12,.cls-3{fill:#ffe28e;}.cls-18,.cls-4{fill:#fff;}.cls-5{fill:url(#radial-gradient);}.cls-6{fill:url(#radial-gradient-2);}.cls-7{fill:#00479b;}.cls-8{fill:url(#linear-gradient-2);}.cls-9{fill:url(#linear-gradient-3);}.cls-10{fill:#4296cf;stroke:#4296cf;}.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-17,.cls-18,.cls-19,.cls-20,.cls-21,.cls-22{stroke-miterlimit:10;}.cls-11{stroke:#ffeab9;}.cls-12{stroke:#ffe28e;}.cls-13{fill:#abd5ef;stroke:#abd5ef;}.cls-14{fill:#d1d4d4;}.cls-14,.cls-18{stroke:#d1d4d4;}.cls-15{fill:url(#radial-gradient-3);}.cls-16{fill:#deb87d;}.cls-17{stroke:#333;}.cls-19{fill:#006aea;stroke:#006aea;}.cls-20,.cls-21,.cls-22{stroke:#fff;}.cls-20{fill:url(#linear-gradient-4);}.cls-21{fill:url(#linear-gradient-5);}.cls-22{fill:url(#linear-gradient-6);}.cls-23{fill:url(#radial-gradient-4);}.cls-24{fill:#a3ccff;}.cls-25{fill:url(#radial-gradient-5);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 519.71,
    y1: 403.5,
    x2: 966.42,
    y2: 403.5,
    gradientTransform: "matrix(0.74, 0, 0.05, 0.87, 119.38, 26.75)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ebf6fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#e9f5fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#e1f0fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#d4e9fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#c2defe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#aad0fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9cc8ff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 616.75,
    cy: 317.74,
    r: 56.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ccc"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 735.57,
    cy: 289.26,
    r: 66.13,
    gradientTransform: "scale(1 1.11)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 640.38,
    y1: 329.06,
    x2: 692.34,
    y2: 329.06,
    gradientTransform: "matrix(0.94, 0, 0, 1.01, 46.81, -5.19)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cc8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#7fb6fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#569ef5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#4b97f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2781ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1073ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006aea"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 625.85,
    y1: 318.63,
    x2: 715.9,
    y2: 318.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9cc8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#75b1fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#1476ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006aea"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 674.23,
    cy: 255.35,
    r: 19.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5c798"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c69c6d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 160.92,
    y1: 153.64,
    x2: 163.71,
    y2: 153.64,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 160.92,
    y1: 179.96,
    x2: 163.71,
    y2: 179.96,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 160.92,
    y1: 165.83,
    x2: 163.71,
    y2: 165.83,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 584.59,
    cy: 358.18,
    r: 37.45,
    gradientTransform: "scale(1 0.93)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 730.88,
    cy: 335.63,
    r: 44.88,
    gradientTransform: "scale(1 1.02)",
    xlinkHref: "#radial-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M513.42,187.65c-5.1,110.8,164.1,469.67,266.83,427.68,55.87-22.84,92.89-164.54,67.38-269C824.12,250.17,754,211.91,695.7,180.12,678.88,170.94,518.21,83.29,513.42,187.65Z",
    transform: "translate(-513.3 -136.96)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M688,161.68H643.48c-10.48,0-19,6.2-19,13.85v53.88c0,7.6,8.39,13.79,18.81,13.84h.23c7,0,12.33-.09,21.3-.28,12.25-.26,13.2-.41,19.72-.48l3.51,0c10.46,0,18.92-6.21,18.92-13.84v-53.1C707,167.88,698.51,161.68,688,161.68Z",
    transform: "translate(-513.3 -136.96)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M688,161.82l-18.74-.07q-9.37,0-18.74,0l-4.68,0c-1.57,0-3.13,0-4.68.12a23,23,0,0,0-8.88,2.61,14.15,14.15,0,0,0-6.39,6.45,9.66,9.66,0,0,0-.92,4.37c.06,1.54.19,3.12.28,4.68.43,6.24,1.07,12.49,1.87,18.74s1.77,12.49,2.68,18.73c.46,3.13.92,6.25,1.33,9.37l.32,2.34a1.85,1.85,0,0,0,0,.25l.06.09a1.51,1.51,0,0,1,.09.18,1.17,1.17,0,0,0,.2.33,4.92,4.92,0,0,0,1.15,1.2,10.5,10.5,0,0,0,1.88,1.17,15.15,15.15,0,0,0,2.49.9,17.79,17.79,0,0,0,5.82.45l9.17-.62c3.09-.18,6.17-.38,9.25-.47s6.19-.23,9.27-.32l4.64-.09c1.55,0,3.14-.05,4.77,0l4.83.09,4.05.15a15.57,15.57,0,0,0,5.4-.9,13.79,13.79,0,0,0,2.07-1,11.17,11.17,0,0,0,1.29-1,2.73,2.73,0,0,0,.67-.8.41.41,0,0,1,.09-.1l.06-.57.12-1.17.25-2.34c.67-6.25,1.57-12.5,2.43-18.74s1.85-12.49,2.65-18.74c.4-3.12.79-6.24,1.1-9.37l.22-2.32.05-1c0-.34-.07-.67-.11-1a10.64,10.64,0,0,0-1.5-4,15.92,15.92,0,0,0-3-3.29,18.7,18.7,0,0,0-3.91-2.37A23.18,23.18,0,0,0,688,161.82Zm0-.27a27.75,27.75,0,0,1,9.27,1.54,19.15,19.15,0,0,1,8,5.27,13.35,13.35,0,0,1,2.54,4.4c.11.42.25.84.34,1.27l.21,1.32.25,2.36c.31,3.13.7,6.25,1.1,9.37.8,6.25,1.75,12.49,2.65,18.74s1.76,12.49,2.42,18.74l.25,2.34.13,1.17.06.6c0,.36,0,.71,0,1.06a18.93,18.93,0,0,1-1.9,8.13,22.64,22.64,0,0,1-4.52,6.26,27.37,27.37,0,0,1-5.67,4.25,33.09,33.09,0,0,1-12.56,4l-1.61.12-1.41.09-2.29.13-4.54.22c-3,.19-6.18.31-9.32.43s-6.29.13-9.46,0-6.33-.13-9.49-.23c-1.58,0-3.16-.12-4.74-.18l-2.37-.11-1.19-.05-.59,0-.67,0a34.8,34.8,0,0,1-6.32-1,30.77,30.77,0,0,1-3.1-1c-1-.4-2-.81-3-1.32a27.39,27.39,0,0,1-5.63-3.71,24.23,24.23,0,0,1-4.68-5.47,18.87,18.87,0,0,1-2.6-7.3,11.92,11.92,0,0,1-.15-2v-1.49c0-.19,0-.22,0-.34l.31-2.34c.42-3.12.88-6.24,1.33-9.37.92-6.24,1.88-12.49,2.69-18.73s1.44-12.5,1.87-18.74l.3-4.7a11.22,11.22,0,0,1,1.37-4.62,13.43,13.43,0,0,1,2.94-3.71,17.51,17.51,0,0,1,3.86-2.7,23.2,23.2,0,0,1,9-2.57c1.56-.13,3.13-.11,4.69-.1l4.68,0q9.38.06,18.74,0Z",
    transform: "translate(-513.3 -136.96)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M588.28,365.58l-9.91-4.69c1.41-2.66,3.64-7,6.22-12.44,3.61-7.63,3.94-9.13,6.73-14.52.94-1.83.81-1.48,8-13.82,4.5-7.75,5.42-9.38,7.63-13.06,2.47-4.1,4.57-7.45,6-9.74l19,12.13c-1.16,1.78-2.92,4.49-5.06,7.81-5.82,9-6.43,10.14-8.36,12.93a145.61,145.61,0,0,1-9.7,12.55c-5,5.72-6.61,6.64-12.24,12.9C592.82,359.8,590,363.35,588.28,365.58Z",
    transform: "translate(-513.3 -136.96)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M588.28,365.58l-5-2.09-5.1-2.23-.37-.17.19-.39,4-8.13c1.3-2.71,3.18-5.16,4.38-7.93s2.39-5.55,3.7-8.27c.67-1.35,1.33-2.71,2.07-4l2.25-3.93,9-15.74c2.94-5.28,6.1-10.42,9.22-15.6l.23-.38.39.25q4.79,3,9.54,6c3.18,2,6.33,4,9.49,6.08l.44.28-.29.43-9.82,14.88-2.46,3.72c-.82,1.24-1.64,2.48-2.53,3.67q-2.62,3.61-5.46,7.06c-1.89,2.3-3.84,4.54-5.9,6.7s-4.21,4.19-6.27,6.33A160.61,160.61,0,0,0,588.28,365.58Zm0,0A177.61,177.61,0,0,1,599.87,352c2-2.15,4.21-4.19,6.22-6.38s3.91-4.47,5.75-6.8,3.6-4.72,5.29-7.16c.87-1.2,1.66-2.46,2.45-3.72l2.38-3.76,9.54-15.06.15.71c-3.17-2-6.35-4-9.5-6.05s-6.32-4.07-9.46-6.13l.62-.14c-3.22,5.1-6.49,10.17-9.53,15.39l-9.28,15.55-2.3,3.9c-.75,1.31-1.41,2.66-2.09,4-1.33,2.71-2.49,5.5-3.75,8.24-.64,1.37-1.14,2.8-1.68,4.21a42.83,42.83,0,0,1-1.81,4.16l-4.14,8.07-.18-.55,4.8,2.45Z",
    transform: "translate(-513.3 -136.96)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M602.6,366.06l-20.9-11.44q20.1-43.41,40.21-86.84l28.25,8.81Z",
    transform: "translate(-513.3 -136.96)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M602.68,366.34l-21.12-11.47-.18-.1.06-.27c.89-4,1.94-7.89,3.09-11.75s2.37-7.69,3.67-11.48c2.59-7.59,5.44-15.06,8.47-22.44s6.24-14.69,9.69-21.88a65.78,65.78,0,0,1,6.39-10.22,50.82,50.82,0,0,1,4-4.73,36.17,36.17,0,0,1,4.88-4.34l.25-.17.09,0,28.26,8.81.16.4a25.39,25.39,0,0,1,2.18,8.65,28.55,28.55,0,0,1-.4,7.63,30.11,30.11,0,0,1-2.13,6.78c-1,2.1-2.15,4.05-3.25,6.06-4.49,8-9.28,15.72-14.23,23.06s-10,14.26-15.07,20.59A188.45,188.45,0,0,1,602.68,366.34Zm-.17-.55c3.11-10.24,6.08-19.26,9-27.89s5.72-16.57,8.71-24.15,6.12-14.73,9.55-21.68c.88-1.72,1.68-3.5,2.7-5.12a19.82,19.82,0,0,1,3.82-4.41,23.36,23.36,0,0,1,5.54-3.55,29.82,29.82,0,0,1,8.12-2.54l.17.41-28.25-8.81.34-.15a36.15,36.15,0,0,1-.15,6.53,50.72,50.72,0,0,1-1,6.12A66.31,66.31,0,0,1,617.35,292c-3.25,7.28-6.74,14.45-10.41,21.54s-7.52,14.09-11.63,21q-3.07,5.16-6.38,10.23c-2.21,3.37-4.5,6.7-7,9.95l-.12-.36Z",
    transform: "translate(-513.3 -136.96)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "236.5 239.33 259.04 229.45 208.03 128.1 185.48 137.98 236.5 239.33"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M749.93,375.94c7.43-3.32,14.83-6.61,22.26-9.87l-.18.51c-3.18-3.69-6.07-7.53-8.9-11.4s-5.52-7.8-8.13-11.78c-5.24-7.95-10.14-16.07-14.81-24.31-1.15-2.06-2.33-4.12-3.45-6.19l-3.36-6.25q-1.67-3.13-3.28-6.29c-1.07-2.11-2.17-4.2-3.13-6.37a72.6,72.6,0,0,1-4.62-13.55,61.23,61.23,0,0,1-1.22-7.33,39.6,39.6,0,0,1-.11-7.88l.48.18-22.54,9.88.18-.51a37.86,37.86,0,0,1,10.07,2.46,25.47,25.47,0,0,1,6.65,3.75,19.2,19.2,0,0,1,4.36,4.82,22.48,22.48,0,0,1,1.5,2.83l1.37,2.9c3.59,7.79,6.8,15.84,9.78,24.42s5.76,17.68,8.54,27.55c1.39,4.95,2.8,10,4.21,15.43S748.49,369.86,749.93,375.94Zm-.26.7a98.12,98.12,0,0,1-8.42-8.33c-2.84-3.06-5.68-6.41-8.55-9.91-5.72-7-11.44-14.82-17-23.12S704.93,318.13,700,309l-1.82-3.42a33.57,33.57,0,0,1-1.7-3.52,30.38,30.38,0,0,1-1.74-16.77,30.59,30.59,0,0,1,3.69-10.2l.19-.51,22.54-9.87.11-.05.37.22a39.71,39.71,0,0,1,6.26,4.79,61.6,61.6,0,0,1,5.16,5.34,73.67,73.67,0,0,1,8.14,11.78c1.16,2.06,2.18,4.2,3.24,6.31s2.09,4.24,3.1,6.38l3,6.42c1,2.14,1.94,4.31,2.92,6.47,3.84,8.65,7.43,17.43,10.7,26.37q2.46,6.69,4.62,13.55c1.43,4.57,2.78,9.18,3.86,13.94l.08.39-.27.12Z",
    transform: "translate(-513.3 -136.96)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M684.62,366.24l-31.26-.68q7.9,27.49,15.8,55l16-.33Q684.87,393.23,684.62,366.24Z",
    transform: "translate(-513.3 -136.96)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M684.37,366.49l-31-.58.35-.45,39.49,48.19-24.54-18.09,16,0-24.14,24.87A198.26,198.26,0,0,0,673.33,398,157.33,157.33,0,0,0,684.37,366.49Zm.5-.5c3,6.17,7,13.42,11.54,22.44A272.06,272.06,0,0,1,709.77,420L718,443.49l-32.36,1.38-16,.68-27,1.15,2.46-19.24,7.88-61.8.06-.46h.29Z",
    transform: "translate(-513.3 -136.96)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M749.42,630,717.6,637.2l-53-255.49,31.83-7.24q12.39,73.36,29,151.39Q736.9,579.32,749.42,630Z",
    transform: "translate(-513.3 -136.96)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M749.71,630.13l-32.07,7.26-.2.05,0-.2c-2.18-10.65-4.48-21.28-6.72-31.92s-4.61-21.25-7.15-31.83-5.33-21.1-8.21-31.6l-8.79-31.49c-5.93-21-11.28-42.08-15.75-63.36A140,140,0,0,1,668.06,431c-.6-5.43-.81-10.93-.95-16.46s-.24-11.05-.68-16.51a139.06,139.06,0,0,0-2.17-16.21l-.07-.32.32-.07,16-3.47,15.93-3.54.1,0,0,.1q2.68,16.08,5.74,32.11c1.09,5.33,1.67,10.75,3.86,15.88s5.54,10,9,14.9,6.53,9.8,8.24,15a51.77,51.77,0,0,1,1.91,7.91l1.54,8q3,16,5.85,32c3.75,21.35,7.22,42.78,10.19,64.35,1.52,10.78,2.85,21.61,4.08,32.48q.9,8.16,1.66,16.36c.23,2.74.48,5.47.68,8.22l.16,2.13c.07.79.12,1.57.16,2.31C749.63,627.56,749.63,628.91,749.71,630.13Zm-.57-.35c-.57-1.42-1.22-2.7-1.79-3.84l-.82-1.64c-.12-.24-.25-.56-.39-.89l-.41-.95c-1.09-2.53-2.13-5.08-3.17-7.63q-3.09-7.64-5.94-15.37c-3.78-10.29-7.37-20.65-10.66-31.08-6.66-20.85-12.42-41.93-17.51-63.17q-3.81-15.93-7.11-32l-1.61-8a50.19,50.19,0,0,1-1.19-8.11c-.36-5.49.69-11.24,2.13-17.06s2.88-11.61,3-17.17-1.12-10.85-1.94-16.23l-5.43-32.17.12.08-15.89,3.7L664.66,382l.25-.39a139,139,0,0,0,4.45,15.73c1.77,5.19,3.92,10.29,5.95,15.42s4.06,10.26,5.68,15.48a140.76,140.76,0,0,1,3.9,15.84c4.37,21.31,7.85,42.79,10.76,64.4l4.46,32.38c1.54,10.79,3.17,21.55,5,32.27s3.9,21.39,6.1,32,4.29,21.32,6.53,32l-.24-.16Z",
    transform: "translate(-513.3 -136.96)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M695.23,374l-46.46,1.3-2.34-90.51c2.64-.29,6.31-.62,10.71-.79,3.92-.14,7-.1,12,0,5.46.08,6.94.2,9.14.23h2c1.71,0,5.16.36,12.69,1.91Z",
    transform: "translate(-513.3 -136.96)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M695.43,374.17l-23.36.61c-7.77.2-15.51.5-23.29.75h-.25v-.26c-.13-3.77-.17-7.54-.52-11.3a105.79,105.79,0,0,0-1.56-11.28,144.2,144.2,0,0,0-6.54-22.48c-2.72-7.47-5.71-14.94-8.12-22.43a148.71,148.71,0,0,1-5.5-22.5l-2.55-15.73,20.49-4.83a99.93,99.93,0,0,1,13.15-2.27c4.21-.36,8.56-.61,12.71-.6,1,0,1.94.05,2.91.1s1.94.09,2.91.16,2,.14,2.87.22l1.18.1h.44l.94,0c.58,0,1.06.08,1.55.13a42,42,0,0,1,4.41.75c1.25.28,2.39.55,3.5.87,2.2.6,4.25,1.26,6.25,2l17.39,6-1.19,13.36c-.77,8.54-1.84,17-3.08,25.22s-2.73,16.18-4.37,23.74-3.34,14.71-5.09,21.35q-1.32,5-2.62,9.58C697.22,368.53,696.33,371.44,695.43,374.17Zm-.41-.39-3.21-13.26q-1.6-6.39-3.2-12.39c-2.13-8-4.24-15.5-6.23-22.59s-3.85-13.77-5.5-20.2-3.07-12.62-4.21-18.72L688.87,306l-5.23-.24c-.81,0-1.59-.05-2.26,0a6.17,6.17,0,0,0-1.39.1s0,0,.09.07l.21,0H680l-1.74.09c-1.06.06-2,.08-3,.09s-1.94,0-2.92,0-2,0-2.92-.05c-.51,0-1,0-1.38,0l-1.32,0c-.88,0-1.76,0-2.65-.11-1.76-.08-3.53-.23-5.3-.41-3.44-.3-6.73-.5-10.14-.69l17.94-20.56A148.86,148.86,0,0,1,662.26,307c-2,7.6-4.62,15.22-7,22.82a144.46,144.46,0,0,0-5.37,22.78A106.21,106.21,0,0,0,649,364c-.15,3.78,0,7.55.07,11.32l-.26-.25c7.7-.18,15.45-.31,23.16-.55Z",
    transform: "translate(-513.3 -136.96)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M674.23,294.13",
    transform: "translate(-513.3 -136.96)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "80.75 511.93 109.13 518.49 163.71 263.13 135.33 256.57 80.75 511.93"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M594.34,648.72l28.17,6.41-.4.25c2.58-21.7,5.86-43.25,9.45-64.74s7.48-42.9,11.63-64.27,8.5-42.68,13.18-63.94c2.46-10.6,5.26-21.12,8.56-31.54q2.45-7.83,5.34-15.55c1.93-5.15,4-10.28,6.42-15.32l.25.4-28.38-6.56.4-.25a79.19,79.19,0,0,1,3.59,17.11A106.27,106.27,0,0,1,653,426.8a120.1,120.1,0,0,1-1.75,15.55c-.92,5.13-2.17,10.23-3.29,15.34-4.65,20.43-9.68,40.82-15.25,61.48s-11.45,41.56-17.84,63c-3.21,10.75-6.45,21.6-9.87,32.67S598.12,637.13,594.34,648.72Zm-.57.36c.77-9.7,1.87-19.77,3-30s2.44-20.64,3.77-31.18c2.71-21.09,5.86-42.75,9.45-64.66s7.6-44.06,12-66.19c1.15-5.53,2.17-11.07,3.52-16.59a145.1,145.1,0,0,1,5.08-16.37,119.93,119.93,0,0,1,7.27-15.84,75.86,75.86,0,0,1,10.41-14.8l.27-.29.13,0,28.38,6.55.24.06v.34c.18,5.6-.06,11.11-.39,16.6s-.85,10.95-1.49,16.37c-1.25,10.86-3,21.62-5.09,32.3q-6.63,31.95-14.1,63.74t-15.66,63.41c-5.52,21.07-11.33,42.08-17.85,62.94l-.1.33-.3-.07Z",
    transform: "translate(-513.3 -136.96)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M752.57,241.34",
    transform: "translate(-513.3 -136.96)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M772.77,221.4",
    transform: "translate(-513.3 -136.96)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M636,343.19",
    transform: "translate(-513.3 -136.96)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M723.94,279.37",
    transform: "translate(-513.3 -136.96)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M706.55,264",
    transform: "translate(-513.3 -136.96)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M742.85,240.28",
    transform: "translate(-513.3 -136.96)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M765.05,676.6c3.65,10.78,5.48,16.17,2.79,18.38-6.4,5.25-33.4-7.07-45.56-26.59-3-4.81-8.26-13.25-4.23-19.42,4.25-6.49,17.17-8,26-4.84C755.42,648.17,759.31,659.64,765.05,676.6Z",
    transform: "translate(-513.3 -136.96)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M690.33,265.77c-1.5,7.23-5.21,9.63-6.1,10.16-6.59,3.9-18.32-.14-26.1-12.26a38.32,38.32,0,0,0,2.47-4.44,31.71,31.71,0,0,0,2.77-8.28,55.39,55.39,0,0,0,.64-7.69c.1-2.21.12-4.44.13-5.8,0-1.68,0-3.1,0-4.12h19.05c-.08,1-.18,2.43-.26,4.12-.09,2-.18,4-.13,6.07a43,43,0,0,0,.77,7.15c0,.1,0,.24.09.39a37.17,37.17,0,0,0,3.49,9C687.93,261.62,689,263.57,690.33,265.77Z",
    transform: "translate(-513.3 -136.96)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M701.82,196.86c-.26,8.49-.5,14.51-3.4,21.19-2.51,5.79-5.75,9.15-8.9,12.41-5.48,5.68-9.25,9.58-14.37,9.58s-8.45-3.69-14.36-9.93c-3.78-4-7.9-8.35-10.63-16-2.14-6-2.35-11-2.63-17.29-.45-10.45-.73-16.7,1.77-22.77,4.73-11.51,16.76-16,25.37-16s20.68,4.47,25.47,16C702.35,179.38,702.17,185.21,701.82,196.86Z",
    transform: "translate(-513.3 -136.96)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M693.52,154.53a59.56,59.56,0,0,0-23.26-4.07c-9.8.25-16.74,2.81-22.26,4.84-3.78,1.4-5.39,3.13-8.55,6.34-2,2-5.25,3.74-5.43,4.51l-1.6,7c-.86,3.76,1.72,7.31,5.78,8.21l.09,0c2.62.61,4.15,1.73,6.52,3.12a76.86,76.86,0,0,0,10.71,4.9,39.91,39.91,0,0,0,16.34,3.06,30.87,30.87,0,0,0,13.57-3.25c4.62-2.42,5.3-4.54,10.8-8.2a48.53,48.53,0,0,1,5-2.91,7.06,7.06,0,0,0,4-8q-.83-4.26-1.63-8.54Z",
    transform: "translate(-513.3 -136.96)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M581.12,681.57c-7.07,8.89-10.6,13.33-8.83,16.35,4.21,7.18,33.66,5,51.65-9.2,4.45-3.5,12.23-9.62,10.54-16.83-1.78-7.59-13.38-13.5-22.71-13.61C599.76,658.14,592.24,667.59,581.12,681.57Z",
    transform: "translate(-513.3 -136.96)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 49.29,
    cy: 139.98,
    rx: 11.14,
    ry: 11.59
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M661.32,473.46l-47.67-2.39a307.45,307.45,0,0,0,16-69.08c4.85-43.67-.55-83.1-5.16-117.27-1-7.38-1.94-13.42-2.58-17.38l38.69-12a512.27,512.27,0,0,1,.72,218.11Z",
    transform: "translate(-513.3 -136.96)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M732.13,478.16,672.5,473.4c.32-5.79.72-15,.78-26.37.15-29.08-2.12-40.53-.27-62.18a240.55,240.55,0,0,1,4.14-27.49c3.91-20.72,8.35-52.72,10-100.85l34.07,6.94c-1.71,19-3.11,39.39-4,61.14-1.26,31.42-2.12,48.66-.84,69.07A360,360,0,0,0,732.13,478.16Z",
    transform: "translate(-513.3 -136.96)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M689.53,348.75",
    transform: "translate(-513.3 -136.96)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 658.34,
    y: 257.34,
    width: 9.89,
    height: 25.48,
    transform: "translate(-553.87 265.33) rotate(-32.79)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 680.18,
    y: 257.87,
    width: 9.89,
    height: 25.48,
    transform: "translate(601.18 732.21) rotate(-147.21)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 162.32,
    cy: 153.64,
    r: 1.39
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-21",
    cx: 162.32,
    cy: 179.96,
    r: 1.39
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-22",
    cx: 162.32,
    cy: 165.83,
    r: 1.39
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M732.13,478.16",
    transform: "translate(-513.3 -136.96)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M575.41,292l-12.13,4,18.06,76.62,23.81-6.13Z",
    transform: "translate(-513.3 -136.96)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M575.36,292.07l-12,4,.08-.13c2.17,6.22,4.12,12.5,6,18.81s3.57,12.64,5.2,19,3.22,12.71,4.68,19.11c.7,3.2,1.26,6.44,1.66,9.72a65.79,65.79,0,0,1,.56,10l-.14-.08,23.81-6.13-.08.16a22.61,22.61,0,0,1-4.09-3.65,30.48,30.48,0,0,1-3-4,32.92,32.92,0,0,1-2.26-4.22c-.65-1.45-1.18-3-1.77-4.46-2.31-6-4.45-12.06-6.54-18.27s-4.1-12.58-6.08-19.19S577.33,299.34,575.36,292.07Zm.1-.21c3,5.14,6,10.75,8.94,16.55s5.92,11.85,8.79,18,5.67,12.55,8.32,19c.65,1.61,1.36,3.19,2,4.84a39.57,39.57,0,0,1,1.45,5.09,35.05,35.05,0,0,1,.72,5.37,21.54,21.54,0,0,1-.37,5.66l0,.14-.05,0-23.82,6.12-.08,0-.06-.1a64.62,64.62,0,0,1-4-9.18c-1.11-3.11-2-6.26-2.86-9.44-1.54-6.37-3-12.77-4.34-19.19s-2.65-12.85-3.82-19.32-2.24-13-3.08-19.49v-.11l.09,0Z",
    transform: "translate(-513.3 -136.96)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 699.87,
    y: 278.2,
    width: 63.7,
    height: 84.95,
    transform: "translate(-358.78 -368.63) rotate(20.07)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M699,306.9l-8.61,9.76,65.37,65.46a.11.11,0,0,0,.16,0l17.2-17.25a.11.11,0,0,0,0-.17Z",
    transform: "translate(-513.3 -136.96)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M699,307c-.63.78-1.37,1.56-2.09,2.38l-2.17,2.43-4.3,4.88v-.11c6.25,6.19,12.39,12.5,18.85,18.49s13.11,11.78,19.69,17.65c3.27,2.95,6.55,5.9,9.72,8.95,1.59,1.52,3.18,3,4.74,4.59s3.15,3.08,4.59,4.75c2.92,3.3,5.34,7.11,8,10.62l.05.06a.49.49,0,0,0-.34-.1.4.4,0,0,0-.18.07l-.06.05.08-.07.33-.26.64-.52,1.27-1.07c.82-.73,1.63-1.47,2.42-2.24l4.69-4.65,4.69-4.64,2.33-2.34.58-.59.28-.3c.08-.09.25-.21.23-.26-.36-.31-.85-.67-1.27-1l-5.23-4c-.87-.66-1.72-1.37-2.65-1.95a16.77,16.77,0,0,0-2.94-1.46c-2.07-.79-4.31-1.21-6.36-1.84a15.41,15.41,0,0,1-5.53-3c-3.32-2.65-6.62-5.32-9.9-8.08-6.58-5.49-13.11-11.22-19.75-17.25S706,313.89,699,307Zm0-.23c6.82,3.95,13.95,8.49,21.18,13.26S734.7,330,742,335.28c3.66,2.66,7.3,5.4,10.92,8.16a20.68,20.68,0,0,1,4.88,5.17c1.41,2.07,2.65,4.35,4.05,6.27a19.08,19.08,0,0,0,2.26,2.6c.8.78,1.69,1.42,2.55,2.12l5.19,4.09c.43.36.86.64,1.29,1.07,0,.11-.07.19-.11.22l-.14.15-.3.29L772,366l-2.34,2.33-4.63,4.7-4.63,4.71c-.77.79-1.51,1.6-2.24,2.43l-1.07,1.26-.52.65-.26.32-.06.08s0,0-.13.12a.59.59,0,0,1-.28.1.66.66,0,0,1-.53-.16l-.1-.08c-3.5-2.72-7.3-5.15-10.6-8.07-1.67-1.45-3.2-3-4.75-4.59s-3.07-3.16-4.58-4.75c-3-3.18-6-6.46-8.94-9.74-5.86-6.58-11.62-13.27-17.62-19.72S696.46,323,690.28,316.72l-.06-.06,0-.06,4.32-4.87,2.13-2.45C697.44,308.47,698.13,307.63,698.94,306.79Z",
    transform: "translate(-513.3 -136.96)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 557.82,
    y: 248.47,
    width: 5.39,
    height: 20.77,
    rx: 1.98,
    transform: "translate(-568.14 71.63) rotate(-20.12)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 170.69,
    cy: 156,
    rx: 9.93,
    ry: 10.33
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformacionmedicaCenfotec);
export default __webpack_public_path__ + "static/media/InformacionmedicaCenfotec.168751c8cf2fd6c01bdcd16a3c714938.svg";
export { ForwardRef as ReactComponent };